var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',[_vm._v("Whats New in Credible")]),_c('hr')])
}]

export { render, staticRenderFns }